import React from 'react';

export const CreateLeadOptIn = () => <span>Create Opt-in Popup</span>;
